<template>
  <el-dialog
    class="tip-off-dialog"
    title="内容举报"
    width="30%"
    :visible.sync="showTipOffDialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="tip-off">
      <div class="tip-off-title">你觉得该内容有什么问题？</div>
      <el-checkbox-group v-model="checkedReasons" @change="handleCheckedReasonsChange">
        <el-checkbox v-for="reason in reasons" :label="reason.id" :key="reason.id">{{reason.text}}</el-checkbox>
      </el-checkbox-group>
      <div class="tip-off-title">便于后台审核，请详述问题</div>
      <el-input
        type="textarea"
        placeholder="请输入（最多200字）"
        maxlength="200"
        :rows="4"
        show-word-limit
        resize="none"
        v-model="content">
      </el-input>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getReason, tipoff } from '@/api/tipOff';
  export default {
    name: 'TipOff',
    props: {
      // 举报对象类型
      sourceType: {
        type: Number,
        required: true,
      },
      // 举报对象ID
      sourceId: {
        type: Number,
        required: true,
      },
      showTipOffDialog: {
        type: Boolean,
        required: true,
      },
    },
    data: () => ({
      reasons: null, //举报原因列表
      checkedReasons: [], // 已选择的举报原因
      content: '', // 举报描述
    }),
    watch: {
      showTipOffDialog() {
        this.showTipOffDialog && this.getTipOffReason();
      }
    },
    created() {
      this.showTipOffDialog && this.getTipOffReason();
    },
    methods: {
      // 获取举报原因
      getTipOffReason() {
        getReason().then(({ data }) => {
          this.reasons = data;
        });
      },
      // 关闭前回调
      handleClose() {
        this.reasons = '';
        this.checkedReasons = [];
        this.$emit('update:showTipOffDialog', !this.showTipOffDialog);
      },
      // 点击举报
      handleSubmit() {
        if (!this.checkedReasons.length) {
          this.$message.warning('请选择举报原因');
          return false;
        }
        this.tipoff();
      },
      // 举报
      tipoff() {
        tipoff({
          content: this.content,
          reason: this.checkedReasons.join(),
          sourceId: this.sourceId,
          sourceType: this.sourceType,
        }).then(() => {
          this.$message.success('举报成功');
        }).finally(() => {
          this.handleClose();
        })
      },
      // 选择举报原因
      handleCheckedReasonsChange(reasons) {
        this.checkedReasons = reasons;
      }
    }
  };
</script>

<style lang="scss" scoped>
.tip-off-dialog {
  /deep/ .el-dialog__header {
    padding: 20px;
    border: 1px solid #eee;
  }
  /deep/ .el-dialog__body {
    padding-top: 0;
  }
}
.tip-off {
  &-title {
    padding: 20px 0;
    font-weight: 600;
  }
}
</style>
